import React from "react";

import "../styles.scss";
import "../scripts";

import {
  primaryBlock,
  PrimaryBlockConfig,
  getDefaultProps,
  KameleonElement,
  SecondaryBlockSize,
  TertiaryBlockSize,
  BlockTheme,
  renderSecondaryBlock,
  renderTertiaryBlock,
  BlockType,
} from "@kameleon-core/lib";
import { Variants } from "@kameleon-util/global-theme";
import { Box } from "theme-ui";

import blockinfo from "./blockinfo.json";
import defaults from "./defaults.json";
import { EyecatcherType, layoutOptions } from "./types/prop-types";

/** Eyecatcher Primary */
const blockConfig: PrimaryBlockConfig = {
  secondaryBlockSize: SecondaryBlockSize.Medium,
  tertiaryBlockSize: TertiaryBlockSize.Default,
  blockType: BlockType.Primary,
  blockTheme: BlockTheme.light,
};

export const Eyecatcher = primaryBlock<EyecatcherType>(
  blockConfig,
  ({
    tagline,
    header,
    description,
    SecondaryBlock,
    TertiaryBlock,
    layoutProps,
  }: EyecatcherType) => {
    const isCenter = layoutProps.placement === "center";
    return (
      <Box className="primary-eyecatcher-text-only-v1">
        <Box className="padding-global">
          <Box className="container-large">
            <Box className="padding-section-large">
              <Box
                className={`cta13_component ${
                  isCenter ? "one-col" : "two-col"
                }`}
              >
                <Box
                  sx={{ order: layoutProps.placement === "right" ? 1 : -1 }}
                  className="margin-bottom margin-small cta13_content-left"
                >
                  {tagline && (
                    <Box className="margin-bottom margin-xsmall">
                      <Variants.TagLine>{tagline}</Variants.TagLine>
                    </Box>
                  )}
                  <Variants.Heading>{header}</Variants.Heading>
                </Box>
                <Box className="cta13_content-right">
                  <Box className="margin-bottom margin-small">
                    {description && (
                      <Variants.ParagraphMedium>
                        {description}
                      </Variants.ParagraphMedium>
                    )}
                    {SecondaryBlock && (
                      <Box className="secondary">
                        {renderSecondaryBlock(SecondaryBlock)}
                      </Box>
                    )}
                    {renderTertiaryBlock(TertiaryBlock)}
                  </Box>
                </Box>
              </Box>
            </Box>
          </Box>
        </Box>
      </Box>
    );
  }
);

Eyecatcher.defaultProps = getDefaultProps<EyecatcherType>(defaults);

export const Element: KameleonElement = {
  component: Eyecatcher,
  blockInfo: blockinfo,
  defaultProps: {
    layoutProps: defaults.layoutProps,
    contentProps: defaults.contentProps,
  },
  layoutOptions,
};
